import { Skeleton } from "../ui/skeleton.tsx"

const ThemeCardLoader = () => {
  return (
    <div className="p-[2px] bg-gradient-to-tr from-purple-400 via-indigo-500 to-pink-600 bg-[size:200%_200%] animate-wave rounded-3xl">
      <div
        className="flex-1 h-32 rounded-3xl p-2 text-white shadow-xl cursor-pointer relative bg-white flex items-start gap-2"
      >
        <div className="absolute inset-4 flex justify-between gap-5">
          <Skeleton className="w-24 aspect-square" />
          <Skeleton className="flex-1 h-4" />
          <Skeleton className="w-12 h-12" />
        </div>
      </div>
    </div>
  )
}

export default ThemeCardLoader
